function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.398 21.904a.871.871 0 01-.796 0 20.002 20.002 0 01-3.743-2.629C5.463 17.131 4 14.7 4 12V4.727c0-.417.278-.78.673-.882l7.111-1.818a.87.87 0 01.432 0l7.11 1.818a.906.906 0 01.674.882V12c0 2.7-1.463 5.13-3.86 7.275a20.002 20.002 0 01-3.742 2.629zm.242-2.237a18.244 18.244 0 002.33-1.76c2.048-1.833 3.252-3.834 3.252-5.907V5.437L12 3.847l-6.222 1.59V12c0 2.073 1.204 4.074 3.252 5.907a18.244 18.244 0 002.97 2.15c.197-.114.411-.244.64-.39z"
});

var SvgShield = function SvgShield(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/shield.f1980b1d.svg";
export { SvgShield as ReactComponent };